var _circle, _circle2, _circle3, _path, _path2, _circle4, _circle5, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBall90 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_25196",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "url(#paint0_radial_51_25196)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_25196)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "#FF6710"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 -6L48.3956 18.5625L75.8954 23.7123L56.6746 44.0425L60.2748 71.7877L35 59.79L9.72523 71.7877L13.3254 44.0425L-5.89543 23.7123L21.6044 18.5625L35 -6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9136 14.3677L51.1411 14.7847L51.6069 14.8716L84.2749 20.9888L61.4419 45.1411L61.1157 45.4858L61.1772 45.9565L65.4536 78.9155L35.4292 64.6636L35.0005 64.4604L34.5708 64.6636L4.54541 78.9155L8.82275 45.9565L8.88428 45.4858L8.55811 45.1411L-14.2759 20.9888L18.3931 14.8716L18.8599 14.7847L19.0864 14.3677L34.9995 -14.812L50.9136 14.3677Z",
    stroke: "white",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.8246,
    cy: 34.8246,
    r: 34.8246,
    fill: "url(#paint1_radial_51_25196)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.719 46.9348C19.0525 46.9348 16.3362 44.6016 15.7093 41.0495H20.4455C20.8286 42.2683 21.9778 43.2782 23.7886 43.2782C26.7836 43.2782 28.3158 40.8057 28.3507 35.8954H27.7238C26.5746 37.2188 24.8682 38.0545 22.6743 38.0545C18.4605 38.0545 15.5004 35.1989 15.5004 30.9852C15.5004 26.3187 19.0177 23.3238 24.0672 23.3238C30.3357 23.3238 33.2609 27.4679 33.2609 35.0945C33.2609 42.7907 30.0222 46.9348 23.719 46.9348ZM20.55 30.811C20.55 33.0746 21.9081 34.7114 24.1021 34.7114C26.4005 34.7114 27.8283 33.1443 27.8283 30.9155C27.8283 28.6519 26.3657 26.9803 24.1369 26.9803C21.8733 26.9803 20.55 28.6171 20.55 30.811ZM45.456 46.9348C39.6403 46.9348 35.8096 42.1987 35.8096 35.1293C35.8096 28.0599 39.6403 23.3238 45.456 23.3238C51.2369 23.3238 55.0676 28.0599 55.0676 35.1293C55.0676 42.1987 51.2369 46.9348 45.456 46.9348ZM40.9289 35.1293C40.9289 40.2137 42.7049 43.1041 45.456 43.1041C48.2072 43.1041 49.9832 40.2137 49.9832 35.1293C49.9832 30.0449 48.2072 27.1545 45.456 27.1545C42.7049 27.1545 40.9289 30.0449 40.9289 35.1293Z",
    fill: "#082037"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_51_25196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2067 29.3832) rotate(49.2364) scale(41.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_51_25196",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.2067 29.3832) rotate(49.2364) scale(41.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBall90);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ball-90.b5e55ebe23f935e9cb2e4a4c330f01e3.svg";